window.VWFS = window.VWFS || {};
VWFS.GenericMapNavigation = function (component) {
	
	var dropdown = null;
    var svgImage = null;
    var input = null;

	/**
     * INIT
     */
    this.init = function () {
	
		dropdown = component.querySelector(".js-generic-map-navigation-dropdown");
		svgImage = component.querySelector(".js-generic-map-navigation-map");
        input = component.querySelector(".js-generic-map-navigation-input-presentation");
        
		// SELECT ALL DROPDOWN-ITEMS
        component.querySelectorAll(".js-generic-map-navigation-dropdown-element").forEach(function (dropdownItem) {
	
			// ADD CLICK-EVENT-LISTENER
            dropdownItem.addEventListener("click", function (event) {
                event.preventDefault();
                
				// OPEN LINK
				var parentNode = event.target.parentNode;
                openLink(parentNode.getAttribute('data-id'), parentNode.getAttribute('data-href'));

            }, true);

        });

        // SLECT ALL AREA-LINKS
        svgImage.querySelectorAll(".js-generic-map-navigation-area-links").forEach(function (areaLink) {
	
			// ADD CLICK-EVENT-LISTENER
			areaLink.addEventListener("click", function (event) {
                event.preventDefault();

				// OPEN LINK
                openLink(event.target.getAttribute('data-id'), event.target.parentNode.getAttribute('href'));

            })
		});

	}
	
	/**
	 * OPEN LINK
	 */
	function openLink(id, hRef) {
		
        if (hRef.startsWith("#")) {
            var sectionAnchor = document.querySelector(hRef);
            if (sectionAnchor !== undefined) {
	
				// REMOVE HIGHLIGHTING OF THE MAP-AREA
                svgImage.querySelectorAll(".is-active").forEach(function (element) {
                    element.classList.remove("is-active");
                });
                var activeSvgArea = svgImage.querySelector("[data-id='" + id + "']");
                activeSvgArea.classList.add("is-active");

                // CLOSE DROPDOWN
                dropdown.classList.remove("is-open");

                // PUT SELECTED VALUE TO INPUT FIELD
                input.innerText = activeSvgArea.getAttribute("data-ref");

				// HIGHLIGHT SELECTED DROPDOWN-ITEM
                dropdown.querySelectorAll(".is-active").forEach(function (element) {
                    element.classList.remove("is-active");
                });
                var dropdownitem = dropdown.querySelector("[data-id='" + id + "']");
                dropdownitem.classList.add("is-active");

                // SCROLL SMOOTH TO ANCHOR
                var smoothScroll = new window.SmoothScroll();
                smoothScroll.animateScroll(sectionAnchor);

            }

        } else {
            window.open(hRef, '_self');
        }

    }

};

/**
 * ON DOCUMENT LOADED
 */
document.addEventListener('DOMContentLoaded', function () {
    
    console.debug("INFO genericmapnavigation.js loaded");

    // ITERATE THROUGH ALL GENERIC-MAP-COMPONENTS AND INIT THEM
    document.querySelectorAll(".js-generic-map-navigation").forEach(
        function (component) {
            new VWFS.GenericMapNavigation(component).init();
        }
    );
    
});
